"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.engineLaunchReference = engineLaunchReference;
exports.engineLaunchIdFromReference = engineLaunchIdFromReference;
/**
 * What a creative-testing batch launched by the launch engine holds in its
 * `queueJobId` instead of a BullMQ job id, and what launchWithAssets and
 * retryBatch return as the batch's reference: `launch:<launchId>`.
 *
 * Shared so the backend that writes the reference and the new-batch page that
 * reads one back from a submit agree on a single format.
 */
const ENGINE_LAUNCH_REFERENCE_PREFIX = "launch:";
function engineLaunchReference(launchId) {
    return `${ENGINE_LAUNCH_REFERENCE_PREFIX}${launchId}`;
}
/** The engine launch a reference names, or null for a queue job id (or nothing). */
function engineLaunchIdFromReference(reference) {
    if (!(reference === null || reference === void 0 ? void 0 : reference.startsWith(ENGINE_LAUNCH_REFERENCE_PREFIX)))
        return null;
    return reference.slice(ENGINE_LAUNCH_REFERENCE_PREFIX.length) || null;
}
